import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ScenarioUpdate } from "@/model";
import scenarioRepository from "@/repository/scenarioRepository";
import { scenarioQueryKeys } from ".";


export const useUpdateScenario = (id: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['scenario', "update", id],
        mutationFn: async (scenario: ScenarioUpdate) => {
            const data = await scenarioRepository.update(id, scenario);
            return data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: scenarioQueryKeys.pageAll() }),
                queryClient.invalidateQueries({ queryKey: scenarioQueryKeys.detail(id) }),
                queryClient.invalidateQueries({ queryKey: scenarioQueryKeys.autocompletes(id) }),
                queryClient.refetchQueries({ queryKey: scenarioQueryKeys.recent() })
            ]);
        }
    });
};
